import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { FlagsProvider } from "@/contexts/FlagsContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Legal from "@/pages/Legal";
import Privacy from "@/pages/Privacy";
import Contact from "@/pages/Contact";


import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import BioGenerator from "@/pages/BioGenerator";
import Admin from "@/pages/Admin";
import Settings from "@/pages/Settings";
import PublicReport from "@/pages/PublicReport";
import ABTesting from "@/pages/ABTesting";
import VerifyEmail from "@/pages/VerifyEmail";
import CheckEmail from "@/pages/CheckEmail";

function PublicOnly({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/dashboard" replace />;
    return children;
}

function DashboardOrOnboard() {
    const { user } = useAuth();
    if (user && !user.onboarded) return <Navigate to="/onboarding" replace />;
    return <Dashboard />;
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/r/:token" element={<PublicReport />} />
            <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
            
            <Route path="/reset-password/:token" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            <Route path="/check-email" element={<CheckEmail />} />
            <Route path="/register" element={<PublicOnly><AuthPage /></PublicOnly>} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardOrOnboard /></ProtectedRoute>} />
            <Route path="/report" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/bio-generator" element={<ProtectedRoute><BioGenerator /></ProtectedRoute>} />
            <Route path="/ab-testing" element={<ProtectedRoute><ABTesting /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <FlagsProvider>
                    <AppRoutes />
                </FlagsProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;



